import ConfirmDialog from './ConfirmDialog';
import AlertDialog from './AlertDialog';
import SelectionPickDialog from './SelectionPickDialog';
import CustomAlertDialog from './CustomAlertDialog';
import InformationDialog from './InformationDialog';
import QuestionnaireDialog from './QuestionnaireDialog';
import DocumentPreviewDialog from './DocumentPreviewDialog';

// there may be other flavors in the future
export {
  AlertDialog,
  ConfirmDialog,
  SelectionPickDialog,
  CustomAlertDialog,
  InformationDialog,
  QuestionnaireDialog,
  DocumentPreviewDialog,
};
